import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './JobStatus.scss';
import { NEW_LINE_CHARACTERS } from 'src/constants/Generals';
import { formatDateWithHour } from 'src/utils/Date';

const JobFailed = ({ jobInfo, startAt, endAt, errorShowMsg, statusText }) => {
  const { t } = useTranslation();
  return (
    <li>
    <p className={styles.title}>
      {jobInfo}
      <br />
      {statusText}
    </p>
    <div className={styles.dates}>
      <dl>
          <dt>{t('components.JobStatus.AllJobStatus.executed_date')}：</dt>
          <dd>{formatDateWithHour(startAt)}</dd>
      </dl>
      <dl>
          <dt>{t('components.JobStatus.AllJobStatus.completed_date')}：</dt>
          <dd>{formatDateWithHour(endAt)}</dd>
      </dl>
    </div>
    <ul>{errorShowMsg && errorShowMsg.split(NEW_LINE_CHARACTERS).map(msg => <li key={msg}>{msg}</li>)}</ul>
  </li>
  );
};

export default JobFailed;
